import { render } from "./ManageOrder.vue?vue&type=template&id=3d8c634a&scoped=true"
import script from "./ManageOrder.vue?vue&type=script&lang=js"
export * from "./ManageOrder.vue?vue&type=script&lang=js"

import "./ManageOrder.vue?vue&type=style&index=0&id=3d8c634a&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/pos_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d8c634a"]])

export default __exports__